import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import Select from "react-select";
import PropTypes from "prop-types";
import { useHeaderTitle } from "~/utils";

const FILTER_TYPES_OPTIONS = [
    { value: "ContractImporter", label: "ContractImporter" },
    { value: "CostPackageImporter", label: "CostPackageImporter" },
    { value: "CPOItemImporter", label: "CPOItemImporter" },
    { value: "GroupNeoImporterWithRevisionTaps", label: "GroupNeoImporterWithRevisionTaps" },
    { value: "LogisticOMCImporter", label: "LogisticOMCImporter" },
    { value: "ServiceOrderTemplateAmendmentImporter", label: "ServiceOrderTemplateAmendmentImporter" },
    { value: "ServiceOrderTemplateImporter", label: "ServiceOrderTemplateImporter" },
    { value: "ServiceOrderTemplateTapImporter", label: "ServiceOrderTemplateTapImporter" },
    { value: "SiteImporter", label: "SiteImporter" },
    { value: "SiteOMCImporter", label: "SiteOMCImporter" },
    { value: "SiteServiceOrderTemplateItemCPMImporter", label: "SiteServiceOrderTemplateItemCPMImporter" },
    { value: "SiteTapImporter", label: "SiteTapImporter" },
    { value: "VendorImporter", label: "VendorImporter" },
    { value: "VOAImporter", label: "VOAImporter" },
    { value: "VoaSummaryImporter", label: "VoaSummaryImporter" },
    { value: "WBSFromSAPImporter", label: "WBSFromSAPImporter" },
    { value: "WBSImporter", label: "WBSImporter" },
    { value: "WiproImporter", label: "WiproImporter" }
];

const FILTER_STATE_OPTIONS = [
    { value: "Enqueued", label: "Enqueued" },
    { value: "Processing", label: "Processing" },
    { value: "Processed", label: "Processed" },
    { value: "Failed", label: "Failed" }
];

const NeoImporterFilter = ({ className, onSubmit = () => { }, setheader, ...props }) => {
    const comp_op = {
        className: ["costpackage_filters", className].join(" ")
    };

    useHeaderTitle(setheader, "Importer Log");

    const handleSubmit = (submitFn, values, { setSubmitting }) => {
        const computeValue = key => (values[key] ? { [key]: values[key].value } : {});
        const processedValues = {
            ...computeValue("type"),
            ...computeValue("state")
        };
        submitFn(processedValues);
        setSubmitting(false);
    };

    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{ type: null, state: null }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                >
                    {formik => {
                        const { values, setFieldValue } = formik;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Type</label>
                                            <Field
                                                name="type"
                                                value={values.type}
                                                component={Select}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                options={FILTER_TYPES_OPTIONS}
                                                onChange={val => setFieldValue("type", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>State</label>
                                            <Field
                                                name="state"
                                                value={values.state}
                                                component={Select}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                options={FILTER_STATE_OPTIONS}
                                                onChange={val => setFieldValue("state", val, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <div className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

NeoImporterFilter.propTypes = {
    className: PropTypes.string,
    onSubmit: PropTypes.func,
    setheader: PropTypes.func
};

export default NeoImporterFilter;
